import React from "react";
import { FiArrowDown } from "react-icons/fi";
import "./SectorDetailHero.css";
import { scrollToElementById } from "../../../../utils/scrollToId";

const SectorDetailHero = ({ sector }) => {
  if (!sector) return null;

  const handleViewDetails = () => {
    scrollToElementById("sector-detail-content");
  };

  return (
    <section className="sectorDetailHero" aria-label={`${sector.title} sector`}>
      <div className="sectorDetailHero-bgWrap">
        <img src={sector.image} alt={sector.title} className="sectorDetailHero-bg" />
        <div className="sectorDetailHero-overlay" aria-hidden />
      </div>

      <div className="sectorDetailHero-content">
        <h1>{sector.title}</h1>
        {/* <p>{sector.description}</p> */}
        <button type="button" className="sectorDetailHero-btn" onClick={handleViewDetails}>
          <span>View details</span>
          <FiArrowDown />
        </button>
      </div>
    </section>
  );
};

export default SectorDetailHero;
